import { useQueryClient } from '@tanstack/react-query';
import { useClient } from 'hooks/useClient';
import { useExperiment } from './useExperiment';
import { DEVICE_TYPES } from 'definitions';

export const useDeviceTargeting = (experimentId: number) => {
  const { experiment } = useExperiment(experimentId);
  const queryClient = useQueryClient();
  const apiClient = useClient();

  const deleteDeviceTargeting = async (id: number) => {
    await apiClient.delete(`/device-targeting/${id}?experimentId=${experimentId}`);
    queryClient.invalidateQueries({ queryKey: ['EXPERIMENT', experimentId] });
  };

  const addDeviceTargeting = async (device: any) => {
    const payload = { device, experimentId };
    await apiClient.post(`/device-targeting`, payload);
    queryClient.invalidateQueries({ queryKey: ['EXPERIMENT', experimentId] });
  };

  return {
    DEVICE_TYPES,
    deviceTargeting: experiment?.deviceTargeting,
    addDeviceTargeting,
    deleteDeviceTargeting,
  };
};
